(() => {
  const cap = 2048;
  const fixOne = (img) => {
    const rw = img.getBoundingClientRect().width;
    if (rw < 2) return;
    const w = Math.min(Math.round(rw * Math.min(window.devicePixelRatio || 1, 2)), cap);
    let changed = false;
    ['src', 'data-src'].forEach((attr) => {
      const v = img.getAttribute(attr);
      if (v && /[?&]width=1(\b|&|$)/.test(v)) {
        img.setAttribute(attr, v.replace(/([?&]width=)1(\b|&|$)/g, '$1' + w + '$2'));
        changed = true;
      }
    });
    const ss = img.getAttribute('srcset');
    if (ss && /[?&]width=1\b/.test(ss)) {
      img.setAttribute('srcset', ss.replace(/([?&]width=)1\b/g, '$1' + w));
      changed = true;
    }
    if (changed) img.removeAttribute('sizes');
  };
  const sweep = () => {
    document.querySelectorAll('img').forEach((img) => {
      const src = img.currentSrc || img.getAttribute('src') || '';
      if (
        /[?&]width=1(\b|&|$)/.test(src) ||
        (img.complete && img.naturalWidth <= 1 && img.getBoundingClientRect().width > 2)
      ) {
        fixOne(img);
      }
    });
  };
  const run = () => {
    sweep();
    [250, 700, 1400, 2600, 4000].forEach((t) => setTimeout(sweep, t));
  };
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
  window.addEventListener('resize', () => setTimeout(sweep, 200), { passive: true });

  document.addEventListener('pointerdown', () => setTimeout(sweep, 400), {
    passive: true,
    capture: true,
  });
})();
